/**
 * Used to get the language name in English from the language code
 */
export const getLanguageName = (languageCode?: string) => {
  switch (languageCode) {
    case 'pt-BR':
      return 'portuguese';
    case 'es':
      return 'spanish';
    case 'en':
    default:
      return 'english';
  }
};
